import { render, staticRenderFns } from "./themes.vue?vue&type=template&id=1cb2ecfd"
import script from "./themes.vue?vue&type=script&lang=js"
export * from "./themes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports